module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('em', [_vm._v("From Former Mayor to Infantry Officer")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURSDAY")]), _vm._v(", N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVEMBER 7, 1861, AT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMP")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKSON IN")]), _vm._v(" the Confederate capital, Company E of the Fourth Georgia Infantry assembled for another day of drilling. Capt. Youel Rust announced to his men that much needed supplies had been received from their home county’s Ladies’ Relief Society. The list included hickory shirts, mattresses, underwear, leggings, socks, blankets, and other comforts. His soldiers must have been delighted. They had departed for Virginia six months earlier, having “left hastily for the scenes of war, carrying with them only such clothing as the necessity of the moment required.”"), _c('a', {
    attrs: {
      "id": "ren24"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en24",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The arrival of the Fourth in Virginia was a homecoming of sorts for Richmond-born Rust. His Scottish first name and English surname honor his heritage. About 1844, in his early twenties, he had left for Georgia and settled in Albany. He married the following year and became active in local government. After the town received its charter in 1853, he became its first mayor and later served as an alderman. By 1861 he had established a reputation as an efficient public servant and a refined gentleman of marked intelligence."), _c('a', {
    attrs: {
      "id": "ren25"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en25",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rust’s leadership abilities made him an obvious choice as an officer in the county militia, the Albany Guards. It formed in 1857, soon after the organization of Dougherty County, a rich agricultural area with a large slave population in the southwestern region of the state. It became Company E of the Fourth Infantry after the war began and was among the first Georgia units dispatched to Virginia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His tenure as company commander lasted one year. Rust resigned after the regiment’s enlistment expired in 1862. The Fourth reorganized and went on to fight with the Army of Northern "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("Virginia from the Seven Days Battles to Appomattox Court House. According to one historian, Rust’s early leadership “did much to bring the regiment to that state of discipline for which it was always celebrated.”"), _c('a', {
    attrs: {
      "id": "ren26"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en26",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After leaving the army, Rust returned to Albany and was welcomed home by his wife, two sons, and two daughters. He worked for many years as a bank cashier and later rose to president of a savings and loan association. He served two stints as town postmaster and played an active role in other local institutions. At his death in 1901 at age seventy-eight, he ranked as the oldest male resident of Albany. Townfolk remembered him as a gallant Confederate soldier who led a long, useful life."), _c('a', {
    attrs: {
      "id": "ren27"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en27",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("27")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-576411e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter4.vue
// module id = 96
// module chunks = 0